<template>
  <v-app
    id="inspire"
    :class="[{
      'box-layout': boxLayout,
      'collapse-sidebar': collapseSidebar,
      'rtl-layout': rtlLayout,
      'application-biz': $route.meta.bizgainLayout
    }]"
  >
    <router-view :auth="auth" :authenticated="authenticated" />
    <notifications group="loggedIn" position="top right" animation-type="velocity" />
    <notifications group="onboarding" position="top right" animation-type="velocity" />
    <notifications
      group="payment"
      position="top right"
      animation-type="velocity"
      :max="1"
    />
    <notifications group="assets" position="top right" animation-type="velocity" />
    <notifications group="creativeEdit" position="top right" animation-type="velocity" />
    <notifications group="creativeBuilder" position="top right" animation-type="velocity" />
    <notifications group="richMediaAdBuilder" position="top right" animation-type="velocity" />
    <notifications group="richMediaAdPreview" position="top right" animation-type="velocity" />
    <notifications group="EmailVerification" position="top right" animation-type="velocity" />
    <notifications group="embed" position="top right" animation-type="velocity" />
    <notifications group="dashboard" position="top right" animation-type="velocity" />
    <notifications group="brandPortal" position="top right" animation-type="velocity" />
    <notifications group="bizgainOnbaording" position="top right" animation-type="velocity" />
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { AuthService } from './appServices/authService';
import { AppService } from './appServices/appService';

import { PushNotifications } from '@capacitor/push-notifications';
import { FCM } from '@capacitor-community/fcm';
import { SplashScreen } from '@capacitor/splash-screen';
import { Capacitor } from '@capacitor/core';
import { DeviceType, SubscriptionType, ClientCode, routeNotificationContentType } from './constants/PushNotification';

const auth = new AuthService();

const { authenticated, authNotifier } = auth;

const appService = new AppService();
const { subscribeUserPushNotification } = appService;

export default {
  data() {
    authNotifier.on('authChange', authState => {
      this.authenticated = authState.authenticated;
    });
    return {
      auth,
      authenticated,
      animation: {
        enter: {
          opacity: [1, 0],
          translateX: [0, -300],
          scale: [1, 0.2]
        },
        leave: {
          opacity: 0,
          height: 0
        }
      }
    };
  },
  mounted() {
    if (
      this.selectedLocale.locale === 'he' ||
      this.selectedLocale.locale === 'ar'
    ) {
      this.$store.dispatch('rtlLayout');
    }

    if (Capacitor.isPluginAvailable('PushNotifications'))
    {
      PushNotifications.requestPermissions();

      // Source: https://github.com/capacitor-community/fcm/issues/99
      // Also post this fix didn't work with Android 12 / but only with Android 10
      PushNotifications.addListener('registration', async ({ value }) => {
        let payload = {
          deviceType: DeviceType.Android,
          clientCode: ClientCode,
          subscriptionType: SubscriptionType.PushNotificaion
        }
        let token = value // Push token for Android

        // Get FCM token instead the APN one returned by Capacitor
        /* eslint-disable */
        if (Capacitor.getPlatform() === 'ios') {
          const { token: fcm_token } = await FCM.getToken();
          token = fcm_token;
          payload.deviceType = DeviceType.IOS;
        }
        payload.token = token;
        this.setPushNotificationToken(token);
        await subscribeUserPushNotification(this.user.id, payload);
        /* eslint-enable */
      })

      PushNotifications.addListener('pushNotificationActionPerformed', async notification => {
        let data = notification.notification.data;
        let contentType = data && data.contentType;
        if (routeNotificationContentType[contentType] && data.businessProfileId) {
          let queryParam = '';
          if (contentType === routeNotificationContentType.REPORT)
          {
            queryParam += `?reportId=${data.reportId}`;
          }
          this.$router.push(`/app/${data.businessProfileId}/${routeNotificationContentType[contentType]}${queryParam}`);
        }
      }
      );

      // Enable the auto initialization of the library
      // FCM.setAutoInit({ enabled: true }).then(() =>
      //   //alert(`Auto init enabled`);
      //   console.log("XXX - Auto init enabled");

      // );

      // Check the auto initialization status
      // FCM.isAutoInitEnabled().then((r) => {
      //   console.log('Auto init is ' + (r.enabled ? 'enabled' : 'disabled'));
      // });
    }

    if (Capacitor.isPluginAvailable('SplashScreen'))
    {
      SplashScreen.hide();
    }
  },
  methods: {
    ...mapActions(['setPushNotificationToken'])
  },
  computed: {
    ...mapGetters([
      'darkMode',
      'collapseSidebar',
      'boxLayout',
      'rtlLayout',
      'selectedLocale',
      'user'
    ])
  }
};
</script>
